const SimpleRandomization = require('./simple');
const BlockedRandomization = require('./blocked');
const RandomBlockRandomization = require('./random-block');
const ClusteredRandomization = require('./clustered');
const ClusterStratifiedRandomization = require('./cluster-stratified');
const StratifiedBlockRandomization = require('./stratified-block');

const randomizers = {
  simple: new SimpleRandomization(),
  blocked: new BlockedRandomization(),
  'random-block': new RandomBlockRandomization(),
  clustered: new ClusteredRandomization(),
  'stratified-blocked': new StratifiedBlockRandomization(
    'stratified-blocked',
    'Stratified Block Randomization (Fixed Block Size)',
    'fixed'
  ),
  'stratified-random-block': new StratifiedBlockRandomization(
    'stratified-random-block',
    'Stratified Random Block Size',
    'random'
  ),
  'cluster-stratum': new StratifiedBlockRandomization(
    'cluster-stratum',
    'Cluster as Stratum Randomization',
    'random',
    {
      strataInputName: 'clusterStrata',
      strataLabel: 'Cluster/Center',
      copyStratumToCluster: true
    }
  ),
  'cluster-stratified': new ClusterStratifiedRandomization()
};

function getRandomizer(id) {
  const randomizer = randomizers[id];

  if (!randomizer) {
    throw new Error(`Unknown randomization technique: ${id}`);
  }

  return randomizer;
}

module.exports = {
  getRandomizer,
  randomizers
};
